/**
 * What counts as "Parse says this session is gone", shared by parseCloud (cloud calls) and
 * authService (session checks). A leaf module with no store or auth imports: parseCloud imports
 * authService, so neither can import the other.
 */

/** Parse.Error.INVALID_SESSION_TOKEN and Parse.Error.SESSION_MISSING. */
const INVALID_SESSION_CODES = [209, 206]

/**
 * A Back4App outage, a dropped connection or a slow request says nothing about the session, so
 * only these two codes may sign the user out.
 */
export function isInvalidSessionError(error: unknown): boolean {
  const code = (error as { code?: number } | null | undefined)?.code
  return typeof code === 'number' && INVALID_SESSION_CODES.includes(code)
}

/** Carried in the `sessionExpired` event detail. */
export const SESSION_EXPIRED_MESSAGE = 'Your session has expired. Please sign in again.'
